import {h, Component, Fragment} from "preact";
import {route} from "preact-router";
import {TicketHeader, TicketBody, EndedTicketPopups} from "../mobile-pages/ticket-ltn.jsx";
import Page from "../../../services/page-data-feed";
import LFeed from "../../../services/live-feed";
import Ticket from "../utils/ticket-logic.jsx";

import FullSite from "./full-site";

import * as M from "../desktop-templates/prematch-menu.jsx";
import * as L from "../desktop-templates/live-general.jsx";
import * as T from "../desktop-templates/prematch-right-col.jsx";
import * as P from "../mobile-templates/sports.jsx";
import * as I from "../utils/icons.jsx";
import * as E from "../desktop-templates/prematch-single-event.jsx";

import LiveMenuSide from "../desktop-components/live-menu-side.jsx";
import LiveEventContent, {LiveTrackerByEventPanel} from "../desktop-components/live-event.jsx";

import TicketCheckBet from "../desktop-components/ticket-check-bet.jsx";
import TicketLoadBet, { TicketLoadCashier } from "../desktop-components/ticket-load-bet.jsx";
import TicketFastBet from "../desktop-components/ticket-fast-bet.jsx";
import Observer from "../utils/observer";

import AwrabetLiveEventClass, {
	FirstLiveEvent as AwrabetFirstLiveEvent
} from "../../awrabet/desktop-pages/live-event.jsx";
import Config from "../config.jsx";
import EmbeddedTracker from "../../tracker/widget.jsx";

const USE_BIG_TRACKER = false;

export default class LiveEventClass extends AwrabetLiveEventClass {
	render({eventId}) {
		return <LiveEvent eventId={eventId} />;
	}
}

export function LiveEvent({eventId}) {
	return <FullSite>
		<LiveEventLayout eventId={eventId} />
	</FullSite>;
}

export function LiveEventLayout({eventId}) {
	return <div class="font-roboto">
		<L.TopRowContainer>
			<L.ContainerLink>
				<L.TopPageLink href="/prematch">sport home</L.TopPageLink>
				<L.TopPageLink href="/live/general">general view</L.TopPageLink>
				<L.TopPageLink active={true}>event view</L.TopPageLink>
			</L.ContainerLink>
		</L.TopRowContainer>
		<div class="flex border-b border-b-harifzinc-950 bg-harifzinc-900 text-white">
			<div class="scrollbar-fancy w-72 flex-none overflow-y-scroll border-r border-r-harifzinc-950">
				<LiveMenuSide/>
			</div>
			<div class="scrollbar-fancy min-w-0 grow overflow-y-scroll border-r border-r-harifzinc-950">
				<LiveEventContent key={eventId} eventId={eventId}/>
			</div>
			<div class="scrollbar-fancy w-72 flex-none overflow-y-scroll border-r border-r-harifzinc-950">
				{!USE_BIG_TRACKER && !!LFeed.getEvent('/event/'+eventId) 
					? (Config.liveTrackerType == 'betradar' 
						? <LiveTrackerByEventPanel
							event={LFeed.getEvent('/event/'+eventId)}
							toggleTrackerType={() => Observer.notify('live-tracker-toggle')}
						/> 
						: <EmbeddedTracker eventId={'/event/'+eventId} isHorizontal={false} info={true} chart={true} stats={false} />) 
					: ''
				}
				<T.ColumnTicketWrappper>
					<T.TicketTopRow>
						<TicketHeader/>
					</T.TicketTopRow>
					<TicketBody/>
					<EndedTicketPopups/>
				</T.ColumnTicketWrappper>
				<M.BlankSeparator/>
				<TicketLoadBet/>
				<M.BlankSeparator/>
				<TicketCheckBet/>
				<M.BlankSeparator />
				<TicketLoadCashier />
			</div>
		</div>
	</div>;
}
export class FirstLiveEvent extends AwrabetFirstLiveEvent {
	render({sportId}) {
		return <LiveEvent />
	}
}